<template>
  <div>
    <vs-button color="danger" type="border" icon-pack="feather" icon="icon-upload" @click="onClickBtnExport">Export</vs-button>
    <div class="vx-row mb-12">
      <div class="core vx-col w-full mb-base md:w-1/1">
        <vs-table
            search
            stripe
            border
            description
            :sst="true"
            :data="table.data"
            :max-items="table.length"
            :total="table.total"
            @search="handleSearch"
            @change-page="handleChangePage"
            @sort="handleSort"
        >
          <template slot="header">
            <vs-dropdown vs-trigger-click class="cursor-pointer">
              <div class="p-3 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium">
                <span class="mr-2">{{ this.table.start }} - {{ this.table.end }} of {{ this.table.total }}</span>
                <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
              </div>
              <vs-dropdown-menu>
                <vs-dropdown-item
                    v-for="item in table.limits"
                    :key="item"
                    @click="handleChangeLength(item)"
                ><span>{{ item }}</span>
                </vs-dropdown-item>
              </vs-dropdown-menu>
            </vs-dropdown>
          </template>
          <template slot="thead">
            <vs-th sort-key="">Created At</vs-th>
            <vs-th sort-key="">Created By</vs-th>
            <vs-th sort-key="">File</vs-th>
            <vs-th sort-key="">Status</vs-th>
          </template>
          <template slot-scope="{ data }">
            <vs-tr :data="tr" :key="index" v-for="(tr, index) in data">
              <vs-td :data="tr">{{ dateFormat(tr.created_at) }}</vs-td>
              <vs-td :data="tr">{{ tr.created_by }}</vs-td>
              <vs-td :data="tr">
                <a target="_blank" v-if="data[index]['file_path'] && data[index]['file_path'] !=''" :href="data[index]['file_path']">
                  {{ data[index]["file_name"] }}
                </a>
                <span v-else>
                  {{ data[index]["file_name"] }}
                </span>
              </vs-td>
              <vs-td :data="tr">{{ tr.status }}</vs-td>
            </vs-tr>
          </template>
        </vs-table>
        <vs-pagination
            style="padding-top: 5px"
            :total="table.totalPage"
            v-model="setPage"
        />
      </div>
    </div>
  </div>
</template>
<script>
import moment from "moment";

export default {
  data() {
    return {
      table: {
        data: [],
        length: 10,
        page: 1,
        search: "",
        order: "id",
        sort: "desc",
        total: 0,
        totalPage: 1,
        totalSearch: 0,
        limits: [10, 25, 50, 100, "All"],
        start: 1,
        end: 0,
      }
    }
  },
  computed: {
    setPage: {
      get() {
        return 1;
      },
      set(val) {
        this.handleChangePage(val);
      },
    },
  },
  methods: {
    handleSearch(searching) {
      this.table.search = searching;
      this.table.page = 1;
      this.getData();
    },
    handleChangePage(page) {
      this.table.page = page;
      this.getData();
    },
    handleSort(key, active) {
      this.table.order = key;
      this.table.sort = active;
      this.getData();
    },
    async onClickBtnExport(){
      try {
        this.$vs.loading();
        const response = await this.$http
            .post(`api/wms/v1/master/shelf-life/export`, {
              extension: 'xlsx'
            })

        if(response.code === 200){
          this.$vs.notify({
            color: "success",
            title: "Success",
            text: "Export process in background",
            position: "top-right",
            iconPack: "feather",
            icon: "icon-x-circle",
          });

          await this.getData();
        } else {
          throw new Error(response.message);
        }
      } catch (error) {
        this.$vs.notify({
          color: "danger",
          title: "Error",
          text: error,
          position: "top-right",
          iconPack: "feather",
          icon: "icon-x-circle",
        });
      } finally {
        this.$vs.loading.close();
      }
    },
    setStartEnd() {
      let valStart =
          this.table.length * this.table.page - this.table.length + 1;

      if (valStart > this.table.total) {
        valStart = 1;
      }
      if (this.table.total == 0) {
        valStart = 0;
      }
      let valEnd = this.table.length * this.table.page;

      if (valEnd > this.table.total) {
        valEnd = this.table.total;
      }

      if (
          this.table.totalSearch < this.table.total &&
          this.table.search != ""
      ) {
        valEnd = this.table.totalSearch;
      }

      this.table.start = valStart;
      this.table.end = valEnd;
    },
    dateFormat(val) {
      return moment(val).utc().format('YYYY-MM-DD HH:mm:ss');
    },
    async getData() {
      console.log("getData")
      try {
        this.$vs.loading();

        const response = await this.$http.get("/api/wms/v1/master/shelf-life/export", {
          params: {
            length: this.table.length,
            page: this.table.page,
            search: this.table.search,
            order: this.table.order,
            sort: this.table.sort,
            type: "shelf-life"
          },
        })

        this.table.total = response.data.total_record
        this.table.totalPage = response.data.total_page
        this.table.totalSearch = response.data.total_record_search
        this.table.length = response.data.total_record_per_page
        this.table.data = response.data.records

        console.log(this.table)
        this.setStartEnd();

      } catch (e) {

      } finally {
        this.$vs.loading.close();
      }
    },
  }
}
</script>